import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgUser = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.008 14.597c.843 0 1.54-.09 2.116-.25.5-.14 1.053.074 1.47.385.621.466 2.906 1.322 2.906 2.846v.964c0 .502-.433.92-.993.958h-11c-.546-.038-.973-.437-.991-.927l-.016-.995c0-1.524 2.3-2.38 2.922-2.846.416-.31.967-.525 1.467-.386.576.162 1.274.251 2.119.251zM12 4c2.705 0 3.5 1.996 3.5 4.5S14.512 13 12 13s-3.5-2-3.5-4.5S9.295 4 12 4z"
      clipRule="evenodd"
    />
  </svg>
));
SvgUser.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgUser;
